import { preview } from '@/components/form/preview'
import { ConvertTime } from '@/components/smartUtils/conversion/ConvertTime'

import { useTexts } from '../useTexts'
import { NumberedLabel } from './NumberedLabel'

interface Props {
  extOrder: uui.domain.client.rm.ExtendedOrderStep
}

export function DetectedCheckOut(props: Props) {
  const { extOrder } = props
  const texts = useTexts()

  const autoTimeOutSec = extOrder.orderStep.trackingData?.autoTimeOutSec ?? -1
  const autoTimeOutDisabled = autoTimeOutSec === -1

  return (
    <preview.Field
      label={
        <NumberedLabel
          number={4}
          label={texts.detectedCheckOut.label}
          color="#64B5F6"
          disabled={autoTimeOutDisabled}
        />
      }
      testId="execution-detected-check-out"
    >
      {autoTimeOutSec > 0 ? (
        <ConvertTime seconds={autoTimeOutSec} showSeconds={false} />
      ) : (
        <preview.NullValue />
      )}
    </preview.Field>
  )
}
